import { Box } from "@mui/material";
import { useNavigationContext } from "../../context/navigation/NavigationContext";
import { sidebarData } from "../../data/dashboard/sidebarData";
import { MobileNavigationList } from "./MobileNavigationList";
import { AccordionContainer } from "../accordion/AccordionContainer";

const MobileNavigation = () => {
  const { isMobileNavigation } = useNavigationContext();

  return (
    <Box
      sx={{
        p: 2,
        position: "fixed",
        top: "58px",
        bottom: "64px",
        bgcolor: "#F2F2F7",
        width: "100vw",
        maxHeight: "100vh",
        overflowY: "auto",
        transform: isMobileNavigation ? "translate(0)" : "translate(-100%,0)",
        transition: "transform .2s ease-in",
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "14px",
        }}
      >
        {sidebarData.slice(3, sidebarData.length).map((data) => (
          <AccordionContainer
            key={data.title}
            title={data.title}
            icon={data.icon}
          >
            <MobileNavigationList data={data} />
          </AccordionContainer>
        ))}
      </Box>
    </Box>
  );
};

export default MobileNavigation;
